<template>
  <div class="new-order-wrapper">
    <h3 class="section-title-centered">{{ title }}</h3>
      <form @submit.prevent="onSubmit">
        <div class="form-row">
          <div class="col-6">
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Name</label>
                <div class="col-sm-7">
                  <input type="text" v-model="obj.name" v-validate="'required'" id="name" name="name" class="form-control" :class="{ 'is-invalid': submitted && errors.has('name') }" />
                  <div v-if="submitted && errors.has('name')" class="invalid-feedback">{{ errors.first('name') }}</div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>DOB</label>
                <div class="col-sm-7">
                  <input v-validate="'date_format:dd/MM/yyyy'" placeholder="DD/MM/YYYY" type="text" v-model="obj.DOB" id="DOB" name="DOB" class="form-control" :class="{ 'is-invalid': submitted && errors.has('DOB') }" />
                  <div v-if="submitted && errors.has('DOB')" class="invalid-feedback">{{ errors.first('DOB') }}</div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Card number</label>
                <div class="col-sm-7">
                  <input type="text" v-model="obj.cardNumber" id="taxId" name="taxId" class="form-control" :class="{ 'is-invalid': submitted && errors.has('taxId') }" />
                  <div v-if="submitted && errors.has('taxId')" class="invalid-feedback">{{ errors.first('taxId') }}</div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label no-wrap" v-translate>Customer Type</label>
                <div class="col-sm-7">
                  <v-select
                    v-model="obj.customerType"
                    v-validate="'required'"
                    :options="customerTypes"
                    label="label"
                    index="value"
                    id="customerType"
                    name="customerType"
                  >
                  </v-select>
                  <div v-if="submitted && errors.has('customerType')" class="invalid-feedback-select">{{ errors.first('customerType') }}</div>
                </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Address</label>
                <div class="col-sm-7">
                  <input type="text" v-model="obj.address" id="address" name="address" class="form-control" />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Phone Number</label>
                <div class="col-sm-7">
                  <input type="text" v-model="obj.phone" v-validate="'required'" id="phone" name="phone" class="form-control" :class="{ 'is-invalid': submitted && errors.has('phone') }" />
                  <div v-if="submitted && errors.has('phone')" class="invalid-feedback" >{{ errors.first('phone') }}</div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label" v-translate>Email</label>
                <div class="col-sm-7">
                  <input type="email" v-model="obj.email" v-validate="'email'" id="email" name="email" class="form-control" :class="{ 'is-invalid': submitted && errors.has('email') }" />
                  <div v-if="submitted && errors.has('email')" class="invalid-feedback">{{ errors.first('email') }}</div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-5 col-form-label no-wrap" v-translate>Preferred drink</label>
                <div class="col-sm-7">
                  <input type="text" v-model="obj.preferredDrink" id="preferredDrink" name="preferredDrink" class="form-control" :class="{ 'is-invalid': submitted && errors.has('preferredDrink') }" />
                  <div v-if="submitted && errors.has('preferredDrink')" class="invalid-feedback">{{ errors.first('preferredDrink') }}</div>
                </div>
            </div>
          </div>
        </div>
        <div class="form-footer py-lg-3 text-center">
          <button type="submit" class="btn btn-primary px-5" v-translate>Ok</button>
        </div>
      </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';
import CustomerService from '@/services/CustomerService';

export default {
  name: 'FormCustomer',
  props: ['title'],
  data() {
    return {
        obj: {customerType: ''},
        submitted: false,
        customers: [],
        selected: '1',
        customerTypes: [],
        showDropdown: true,
    }
  },
  computed: {
    ...mapState(['customer']),
  },
  async created() {
    const customerTypes = await CustomerService.getCustomerTypeList();
    if(!customerTypes) return;
    this.customerTypes = customerTypes;
    const transformedCustomerTypes = [{label: this.$gettext('Choose Customer Type'), value: ''}];
    this.customerTypes.forEach((customer) => {
      transformedCustomerTypes.push({
        label: customer.name,
        value: customer.id,
      });
    });
    this.customerTypes = transformedCustomerTypes;
    this.obj.customerType = (this.customerTypes.length>0) ? ((1*this.customerTypes[0].value != '') ? 1*this.customerTypes[0].value : '') : '';
  },
  methods: {
    async onSubmit(e) {
      this.submitted = true;
      const valid = await this.$validator.validate();

      if (valid) {
        if(typeof(this.obj.DOB) !== 'undefined' && this.obj.DOB !== '') {
          const arrDate = this.obj.DOB.split('/');
          this.obj.DOB = arrDate[2] + '-' + arrDate[1] + '-' + arrDate[0];
        }
        const response = await this.$store.dispatch('postCustomer', this.obj);

        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Customer added successfully'));
        this.submitted = false;
        this.obj = {customerType: ''};

      }
    },
  },
};
</script>
